<div class="header-with-tag">
  <app-upload-files-header
    title="Upload File"
    description="Upload one file per slot below. Each file must contain at least the required headers listed. Additional columns are fine - they'll be ignored."
  ></app-upload-files-header>
  <nz-tag class="column-mapping-saved-tag">
    <span nz-icon nzType="check-circle" nzTheme="outline"></span>
    Column Mapping Saved
  </nz-tag>
</div>

<div class="exists-upload-file-section">
  <div class="file-card" *ngFor="let fileConfig of existingFileConfig; let i = index">
    <div class="file-card-header">
      <h3>{{ fileConfig.displayName }}</h3>
      <p>{{ fileConfig.description }}</p>
    </div>
    <div class="file-card-body">
      <div class="headers-action-row">
        <div class="required-headers-section">
          <span class="required-headers-label">Required Headers:</span>
          <div class="tags-container">
            <!-- Show all required headers before validation -->
            <nz-tag
              class="header-tag"
              *ngFor="let field of targetColumns"
              [ngClass]="{ 'validated-tag': isFieldMatched(i, field.key), 'missing-tag': isFieldMissing(i, field.key) }"
            >
              <span
                *ngIf="isFieldMatched(i, field.key)"
                nz-icon
                nzType="check-circle"
                nzTheme="outline"
                class="validated-icon"
              ></span>
              <span
                *ngIf="isFieldMissing(i, field.key)"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                class="missing-icon"
              ></span>
              {{ field.tagName }}
            </nz-tag>
          </div>
        </div>
        <button
          nzSize="large"
          nz-button
          nzType="default"
          class="validate-btn"
          [class.validated-btn]="headerValidation[i]?.headersValidated"
          [class.missing-btn]="hasMissingHeaders(i) || hasDuplicateHeaders(i)"
          (click)="validateHeaders(i)"
          [disabled]="
            headerValidation[i]?.headersValidated ||
            !(fileConfig.fileItem && fileConfig.fileItem.uploadedFileList.length)
          "
        >
          <span
            nz-icon
            [nzType]="
              hasMissingHeaders(i)
                ? 'exclamation-circle'
                : hasDuplicateHeaders(i)
                  ? 'exclamation-circle'
                  : headerValidation[i]?.headersValidated
                    ? 'check-circle'
                    : 'search'
            "
            nzTheme="outline"
          ></span>
          {{ headerValidation[i]?.headersValidated ? 'Headers Validated' : 'Validate Headers' }}
        </button>
      </div>

      <div class="upload-box">
        <nz-upload
          nzType="drag"
          [nzMultiple]="false"
          [nzBeforeUpload]="getBeforeUploadHandler(i)"
          [nzRemove]="getRemoveHandler()"
          [nzShowUploadList]="true"
          [nzFileList]="fileConfig.fileItem.uploadedFileList || []"
          accept=".csv"
        >
          <p class="ant-upload-drag-icon">
            <span nz-icon nzType="upload"></span>
          </p>
          <p><strong>Click to Upload</strong> or drag and drop the CSV file</p>
          <p class="upload-hint">Maximum file size 100MB</p>
        </nz-upload>
        <div
          class="validation-success-text"
          *ngIf="
            headerValidation[i]?.headersValidated && fileConfig.fileItem && fileConfig.fileItem.uploadedFileList.length
          "
        >
          <span nz-icon nzType="check-circle" nzTheme="outline"></span>
          All Required Headers are present
        </div>
        <div
          class="validation-missing-text"
          *ngIf="hasMissingHeaders(i) && fileConfig.fileItem && fileConfig.fileItem.uploadedFileList.length"
        >
          <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
          Missing Required Header(s): {{ getMissingHeadersText(i) }}
        </div>
        <div
          class="validation-missing-text"
          *ngIf="hasDuplicateHeaders(i) && fileConfig.fileItem && fileConfig.fileItem.uploadedFileList.length"
        >
          <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
          Duplicate Header(s): {{ getDuplicateHeadersText(i) }}
        </div>
      </div>
    </div>
  </div>

  <div class="actions-row">
    <button nz-button nzType="text" class="clear-btn" (click)="clearAllFiles()" [disabled]="!hasAnyFile">
      <span nz-icon nzType="reload" nzTheme="outline"></span>
      Clear All Files
    </button>
    <div class="action-buttons">
      <button
        nzSize="large"
        nz-button
        nzType="default"
        class="validate-files-btn"
        (click)="validateFiles()"
        [disabled]="!canValidateFiles || isValidatingFiles"
        [nzLoading]="isValidatingFiles"
      >
        Validate File
      </button>
      <button
        nzSize="large"
        nz-button
        nzType="default"
        class="process-btn"
        (click)="processFiles()"
        [disabled]="!canProcessFiles || isProcessing"
        [nzLoading]="isProcessing"
      >
        Process File
      </button>
    </div>
  </div>

  <app-validation-logs [logs]="validationLogs"></app-validation-logs>

  <div class="export-row">
    <button
      nzSize="large"
      nz-button
      nzType="default"
      class="export-btn"
      (click)="publishFile()"
      [disabled]="(uploadFilesService.isFileProcessed$ | async) !== true || isPublishing"
      [nzLoading]="isPublishing"
    >
      <span nz-icon nzType="upload" nzTheme="outline"></span>
      Publish Processed File
    </button>
  </div>
</div>
